export default "__VITE_ASSET__3aebb48f__"